import { ApolloClient, from, HttpLink, InMemoryCache } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import { devURL } from "../constants/Common";

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, extensions }) => {
      if (extensions?.code === 'UNAUTHENTICATED') {
        localStorage.removeItem('token');
        window.location.href = '/signin';
      } else {
        console.error(`GraphQL error: ${message}`);
      }
    });
  }
  if (networkError) {
    const code = networkError?.result?.errors?.[0]?.extensions?.code;
    if (code === 'UNAUTHENTICATED') {
      localStorage.removeItem('token');
      window.location.href = '/signin';
    } else {
      const networkErrorMessage = networkError?.message || String(networkError);
      console.error(`Network error: ${networkErrorMessage}`);
    }
  }
});

const link = from([errorLink, new HttpLink({ uri: devURL })]);

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = localStorage.getItem("token");
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});

const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: authLink.concat(link),
});

export default client;
